import { render, staticRenderFns } from "./PhilhealthContributionDetails.vue?vue&type=template&id=0ed8bae0&scoped=true"
import script from "./PhilhealthContributionDetails.vue?vue&type=script&lang=js"
export * from "./PhilhealthContributionDetails.vue?vue&type=script&lang=js"
import style0 from "./PhilhealthContributionDetails.vue?vue&type=style&index=0&id=0ed8bae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8bae0",
  null
  
)

export default component.exports